<template>
  <div>
    <div class="mob-nav">
      <v-navigation-drawer v-model="drawer" absolute temporary app width="150" height="100%" style="position:fixed">
        <v-list class="pt-5">
          <v-list-tile active-class="blue--text" to="/">
            <v-list-tile-content>
              <v-list-tile-title>HOME</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile active-class="blue--text" to="/resume">
            <v-list-tile-content>
              <v-list-tile-title>RESUME</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile active-class="blue--text" to="/services">
            <v-list-tile-content>
              <v-list-tile-title>SERVICES</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile active-class="blue--text" to="/portfolio">
            <v-list-tile-content>
              <v-list-tile-title>PORTFOLIO</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          </v-list-tile>
          <v-list-tile active-class="blue--text" to="/contact">
            <v-list-tile-content>
              <v-list-tile-title>CONTACT</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
    </div>
    <div class="web-nav">
      <v-toolbar flat dense>
        <v-toolbar-side-icon class="hidden-md-and-up" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <v-toolbar-title class="headline">
          <span class="font-weight-light">Midhun</span>
          <span class="blue--text">Nair</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="changeTheme" depressed small icon class="hidden-md-and-up">
          <v-icon v-if="goDark==true">fas fa-sun</v-icon>
          <v-icon v-else>fas fa-moon</v-icon>
        </v-btn>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn flat to="/" active-class="blue--text headline">Home</v-btn>
          <v-btn flat to="/resume" active-class="blue--text headline">Resume</v-btn>
          <v-btn flat to="/services" active-class="blue--text headline">Services</v-btn>
          <v-btn flat to="/portfolio" active-class="blue--text headline">Portfolio</v-btn>
          <v-btn flat to="/contact" active-class="blue--text headline">Contact</v-btn>
          <v-btn @click="changeTheme" depressed small icon>
            <v-icon v-if="goDark==true">fas fa-sun</v-icon>
            <v-icon v-else>fas fa-moon</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    goDark: {
      type: Boolean
    }
  },
  data() {
    return {
      drawer: null
    };
  },
  methods: {
    changeTheme() {
      this.$emit("changeTheme", this.goDark);
    }
  }
};
</script>

<style scoped>
  .web-nav{
  z-index: 100;
  position: fixed;
  top: 0;
  height: 48px;
  width: 100%;
  left: 0;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }

</style>